(() => {
  const SELECTORS = {
    logo: '.header-logo',
    svg: '.header-logo__svg',
  };
  const OVERLAY_ID = 'logo-blend-overlay';
  const MOBILE_BREAKPOINT = '(max-width: 749px)';

  let overlay = null;
  let originalLogo = null;
  let rafId = null;

  const createOverlay = () => {
    originalLogo = document.querySelector(SELECTORS.logo);
    const originalSvg = document.querySelector(SELECTORS.svg);
    if (!originalLogo || !originalSvg) return false;

    const existing = document.getElementById(OVERLAY_ID);
    if (existing) existing.remove();

    overlay = document.createElement('logo-blend');
    overlay.id = OVERLAY_ID;
    overlay.innerHTML = originalSvg.outerHTML;
    overlay.style.cssText = `
      position: fixed;
      z-index: 9999;
      pointer-events: none;
      mix-blend-mode: difference;
      color: white;
      display: flex;
      justify-content: center;
      isolation: auto;
    `;

    originalLogo.style.opacity = '0';
    document.documentElement.appendChild(overlay);

    const mobileMedia = window.matchMedia(MOBILE_BREAKPOINT);
    const applyAlign = () => {
      overlay.style.alignItems = mobileMedia.matches ? 'center' : 'flex-start';
    };
    applyAlign();
    mobileMedia.addEventListener('change', applyAlign);

    return true;
  };

  const updatePosition = () => {
    if (!overlay || !originalLogo) return;
    if (!document.body.contains(originalLogo)) {
      originalLogo = document.querySelector(SELECTORS.logo);
      if (!originalLogo) return;
      originalLogo.style.opacity = '0';
    }
    const rect = originalLogo.getBoundingClientRect();
    overlay.style.top = rect.top + 'px';
    overlay.style.left = rect.left + 'px';
    overlay.style.width = rect.width + 'px';
    overlay.style.height = rect.height + 'px';
  };

  const scheduleUpdate = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      updatePosition();
      rafId = null;
    });
  };

  const init = () => {
    if (!createOverlay()) return;
    updatePosition();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    
    const header = document.querySelector('header-component, .header');
    if (header) {
      const mo = new MutationObserver(() => {
        const currentLogo = document.querySelector(SELECTORS.logo);
        if (currentLogo && currentLogo !== originalLogo) {
          originalLogo = currentLogo;
          originalLogo.style.opacity = '0';
        }
        scheduleUpdate();
      });
      mo.observe(header, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }

 
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(scheduleUpdate);
      if (originalLogo) ro.observe(originalLogo);
      if (header) ro.observe(header);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  let retries = 0;
  const ensureReady = () => {
    if (document.getElementById(OVERLAY_ID)) return;
    if (retries++ < 10) {
      setTimeout(() => {
        init();
        ensureReady();
      }, 100);
    }
  };
  setTimeout(ensureReady, 50);
})();